module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/column-ordering/column-ordering.component.css
// module id = ./src/app/examples/column-ordering/column-ordering.component.css
// module chunks = main